import { Component, Inject, OnInit, ChangeDetectionStrategy } from '@angular/core';

import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { SharedModule } from 'src/app/shared/shared.module';
import { ReportTemplate, TemplateContext } from 'src/app/models/reportTemplate.model';
import { LivePreviewBuilderService } from '../report-template-editor/live-preview-builder.service';
import { TemplateProcessorService } from '../report-generation-popup/services/template-processor.service';
import { PdfGeneratorService } from '../report-generation-popup/services/pdf-generator.service';
import { sanitizeReportHtml } from 'src/app/shared/helpers/report-html-sanitizer.helper';

export interface ViewDialogData {
  template: ReportTemplate;
}

@Component({
    standalone: true,
    selector: 'app-report-template-view-dialog',
    imports: [SharedModule],
    providers: [LivePreviewBuilderService, PdfGeneratorService, TemplateProcessorService],
    templateUrl: './report-template-view-dialog.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrls: ['./report-template-view-dialog.component.scss']
})
export class ReportTemplateViewDialogComponent implements OnInit {
  previewHtml = '';
  isLoading = true;

  constructor(
    private dialogRef: MatDialogRef<ReportTemplateViewDialogComponent>,
    private livePreviewBuilder: LivePreviewBuilderService,
    @Inject(MAT_DIALOG_DATA) public data: ViewDialogData
  ) {}

  async ngOnInit(): Promise<void> {
    const template = this.data.template;
    const layoutHtml = template.templateJson?.layoutHtml ?? '';

    try {
      this.previewHtml = await this.livePreviewBuilder.buildHtml({
        html: layoutHtml,
        entityType: template.entityType,
        templateContext: this.buildPreviewContext(),
        printOptions: template.templateJson?.printOptions ?? null,
        previewMode: true
      });
    } catch {
      this.previewHtml = sanitizeReportHtml(layoutHtml);
    } finally {
      this.isLoading = false;
    }
  }

  close(): void {
    this.dialogRef.close();
  }

  private buildPreviewContext(): TemplateContext {
    return {
      entities: {},
      computedData: {},
      userInputs: {},
      copyrightYear: String(new Date().getFullYear())
    };
  }
}
